import { Grid, Paper } from '@material-ui/core';
import React from 'react';
import { EnvelopeIcon, PhoneIcon, UserIcon } from '../../../icons';
import CartItemInfo from '../../cart/components/CartItemInfo';
import { formatPhone } from '../../../helpers/phoneUtils';

const GuestInfo = ({ customer }) => {
    if (!customer) {
        return null;
    }

    return (
        <Grid item>
            <Paper className="colorcard padded guest-info" elevation={2}>
                <CartItemInfo
                    icon={<UserIcon />}
                    title="Guest"
                    value={`${customer.firstname} ${customer.lastname}`}
                />
                <CartItemInfo icon={<PhoneIcon />} title="Phone" value={formatPhone(customer.phone)} />
                <CartItemInfo
                    icon={<EnvelopeIcon />}
                    title="Email"
                    value={customer.email.split(',')}
                />
            </Paper>
        </Grid>
    );
};

export default GuestInfo;
